export default "__VITE_ASSET__BKyXiik$__"